module.exports = __webpack_public_path__ + "img/35.2ebf3da1.jpeg";